import React, { ReactElement } from 'react';
import {
  Accordion, Nav, Navbar,
} from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { toggleSidebar } from 'store/Settings';
import { logoutSession } from 'utils/authSession';
import logo from 'assets/img/logo-white-full.png';
import { useNavigate } from 'react-router';
import {
  DASHBOARD, DOCUMENTATION, FUNDS, HISTORIC, OPPORTUNITIES, PROJECTS,
} from 'constants/routes';
import { NavLink } from 'react-router-dom';
import { PromotionSummary } from 'types/Project';
import { convertToSlug } from 'utils/utils';
import { selectUserRole } from 'store/User';
import { ReactComponent as IconToggler } from 'assets/icons/toggler.svg';
import { ReactComponent as IconTv } from 'assets/icons/tv.svg';
import { ReactComponent as IconCalendar } from 'assets/icons/calendar.svg';
import { ReactComponent as IconBuilding } from 'assets/icons/building.svg';
import { IoDocumentsOutline } from 'react-icons/io5';

function MenuItem( { icon, text }: { icon: ReactElement, text: string } ) {
  return (
    <>
      {icon}
      <div className="menu-text">
        {text}
      </div>
    </>
  );
}

function Sidebar( { promotionsSummary }:{ promotionsSummary:PromotionSummary[] } ) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userRole = useSelector( selectUserRole );

  const handleLogout = async () => {
    await logoutSession( dispatch );
  };

  return (
    <Nav className="nav-sidebar">
      <Navbar.Brand className="p-0 cursor-pointer" onClick={() => navigate( '/' )}>
        <img src={logo} alt="Grupo Impar" height={30} />
        <div className="toggle text-center d-none d-md-block">
          <IconToggler width={20} onClick={() => dispatch( toggleSidebar() )} />
        </div>
      </Navbar.Brand>

      <Accordion className="mt-5">
        <Accordion.Item eventKey="globalPosition">
          <Nav.Link as={NavLink} to={DASHBOARD}>
            <MenuItem
              icon={<IconBuilding width={20} />}
              text="Posición global"
            />
          </Nav.Link>
        </Accordion.Item>

        <Accordion.Item eventKey="investments">
          <Accordion.Header>
            <MenuItem
              icon={<i className="icon-briefcase" />}
              text="Mis Inversiones"
            />
          </Accordion.Header>
          <Accordion.Body>
            {promotionsSummary.map( ( item ) => (
              <Nav.Link
                key={item.codigoPromocion}
                as={NavLink}
                to={item.tipoDeProyecto === 'Fondo'
                  ? `${FUNDS}/${item.promocionId}/${convertToSlug( item.codigoPromocion )}`
                  : `${PROJECTS}/${item.promocionId}/${convertToSlug( item.codigoPromocion )}`}
              >
                {item.codigoPromocion}
              </Nav.Link>
            ) )}
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="oportunities">
          <Nav.Link as={NavLink} to={OPPORTUNITIES}>
            <MenuItem
              icon={<IconTv width={20} />}
              text="Oportunidades"
            />
          </Nav.Link>
        </Accordion.Item>

        <Accordion.Item eventKey="calendar">
          <Nav.Link as={NavLink} to="/calendar">
            <MenuItem
              icon={<IconCalendar width={20} />}
              text="Calendario"
            />
          </Nav.Link>
        </Accordion.Item>

        <Accordion.Item eventKey="historic">
          <Nav.Link as={NavLink} to={HISTORIC}>
            <MenuItem
              icon={<i className="icon-tv" />}
              text="Histórico"
            />
          </Nav.Link>
        </Accordion.Item>

        <Accordion.Item eventKey="documentation">
          <Nav.Link as={NavLink} to={DOCUMENTATION}>
            <MenuItem
              icon={<IoDocumentsOutline width={20} />}
              text="Documentación"
            />
          </Nav.Link>
        </Accordion.Item>

        {userRole === 'Admin' && (
          <Accordion.Item eventKey="admin" style={{ marginTop: 32 }}>
            <Nav.Link as={NavLink} to="/admin">
              <MenuItem
                icon={<i className="icon-folder" style={{ fontSize: 15 }} />}
                text="Administración"
              />
            </Nav.Link>
          </Accordion.Item>
        )}

        {/* <Accordion.Item eventKey="support" style={{ marginTop: 32 }}>
          <Nav.Link as={NavLink} to="/support">
            <MenuItem
              icon={<i className="icon-support" />}
              text="Soporte"
            />
          </Nav.Link>
        </Accordion.Item> */}

        <Accordion.Item eventKey="logout" style={{ marginTop: 32 }} className="accordion-item-logout">
          <Nav.Item onClick={handleLogout}>
            <MenuItem
              icon={<i className="icon-logout" />}
              text="Logout"
            />
          </Nav.Item>
        </Accordion.Item>
      </Accordion>
    </Nav>

  );
}

export default Sidebar;
